import Multiselect from 'vue-multiselect';
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        userData.permissions['view_nursery'] == 1 ||
          userData.permissions['class_mgt'] == 1
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-detail size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i>New Subject Detail</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select
                    >entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filteron"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(subjectname)="data">
                  {{ data.item.name.name }}
                </template>
                <template #cell(class)="data">
                  {{ data.item.class.name }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="edit(data.item.id, data.item.detail)"
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                      ><i class="mdi mdi-square-edit-outline"></i
                    ></b-button>
                    <b-button
                      @click="remove(data.item.id)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                      ><i class="mdi mdi-trash-can"></i
                    ></b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-detail"
        centered
        title="New Subject Detail"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addDetail">
          <div class="form-group mb-2">
            <label>Class</label>
            <multiselect
              :options="
                schoolclasses.filter((schoolclass) => schoolclass.level == 2)
              "
              placeholder="Select Class"
              label="name"
              v-model="schoolclass"
              :reduce="(schoolclasses) => schoolclasses.id"
            ></multiselect>
            <label>Term</label>
            <multiselect
              v-model="schoolterm"
              label="name"
              :options="schoolterms"
            ></multiselect>
            <label>Year</label>
            <v-select
              :options="years"
              placeholder="Select Year"
              v-model="year"
            ></v-select>
            <label>Subject name</label>
            <multiselect
              v-model="subjectname"
              label="name"
              placeholder="Select Subject"
              :options="
                schoolsubjects.filter(
                  (subjectname) => subjectname.entrystatus === 'Nursery',
                )
              "
              :reduce="(subjectname) => subjectname.id"
            ></multiselect>
            <label>Subject Detail</label>
            <textarea
              rows="6"
              v-model="detail"
              type="text"
              class="form-control"
            ></textarea>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn ms-1 w-30"
              variant="secondary"
              @click="$bvModal.hide('new-detail')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i>Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-detail"
        centered
        title="Edit Subject Detail"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="editDetail">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <!-- <label>Subject Name</label>
                     <multiselect v-show="nurserySubjects.length > 0" v-model="subjectname" label="name" placeholder="Select Subject" :options="nurserySubjects" :reduce="subject => subject.id"></multiselect>
                     
                    <input v-model="subjectname.name" label="name" type="text" readonly class="form-control" /> -->
            <label>Subject detail</label>
            <input v-model="detail" type="text" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn ms-1 w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-detail')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i>Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="remove-detail"
        centered
        title="Delete Subject Detail"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeDetail">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Detail <b> {{ detail }}</b> ??
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn ms-1 w-30"
              variant="secondary"
              @click="$bvModal.hide('remove-detail')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i>Yes</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schoolsubjectComputed,
  schoolsubjectMethods,
  schooltermComputed,
  schooltermMethods,
  subjectdetailsComputed,
  subjectdetailsMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Subject Details",
    meta: [{ name: "descriptions", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Subject Details",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Subject Details", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filteron: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "subjectname", label: "Subject", visible: true },
        { key: "class", label: "Class", visible: true },
        { key: "term", label: "Term", visible: true },
        { key: "detail", label: "Detail", visible: true },
        { key: "addedby", label: "Added By", visible: false },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      schoolclass: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      subjectname: "",
      detail: "",
      entrystatus: "",
      name: "",
    };
  },
  computed: {
    ...subjectdetailsComputed,
    ...schoolsubjectComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    List() {
      return this.subjectdetails.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.subjectdetails.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.subjectdetails.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
    // nurserySubjects() {
    //   if (!this.schoolclass.id) return [];

    //   return this.schoolsubjects.filter(
    //     (subject) =>
    //       subject.schoolclass &&
    //       subject.schoolclass.id === this.schoolclass.id &&
    //       subject.schoolclass.level === 2,
    //   );
    // },
  },
  mounted() {
    this.fetchSubjectDetails();
    this.fetchSchoolSubjects();
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.TotalRows = this.subjectdetails.length;
    this.isBusy = false;
  },
  methods: {
    ...subjectdetailsMethods,
    ...schoolsubjectMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, detail) {
      this.id = id;
      // this.name=name;
      this.detail = detail;
      this.$bvModal.show("edit-detail");
    },
    remove(id, detail) {
      this.id = id;
      this.detail = detail;
      this.$bvModal.show("remove-detail");
    },
    async addDetail() {
      let formData = new FormData();
      formData.append("name", this.subjectname.id);
      formData.append("detail", this.detail);
      formData.append("class", this.schoolclass.id);
      formData.append("year", this.year);
      formData.append("term", this.schoolterm.name);
      let url = "/addsubjectdetail";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSubjectDetails();
          this.$bvModal.hide("new-detail");
          this.name = "";
          this.detail = "";
          this.year = "";
          this.class = "";
          this.term = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editDetail() {
      let formData = new FormData();
      formData.append("detail", this.detail);
      let url = "/updatesubjectdetail";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSubjectDetails();
          this.$bvModal.hide("edit-detail");
          this.detail = "";
          this.$swal({
            title: "Successfully updated",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeDetail() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesubjectdetail";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSubjectDetails();
          this.$bvModal.hide("remove-detail");
          this.$swal({
            title: "Successfully deleted",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
